export default "__VITE_ASSET__DEli$mT2__"